export default function SectionContainer({ children, card }) {
    let className = 'section-container'

    return (
        <section className={className}>
            {card ? <div className="section-card">{children}</div> : children}
        </section>
    )
}
